import { createStyles } from '@material-ui/styles';
import palette from 'theme/palette';

export default () =>
  createStyles({
    buttonsBase: {
      borderTop: `1px solid ${palette.borderGray}`,
      padding: 10,
    },
    buttonsAlign: {
      justifyContent: 'flex-end',
      display: 'flex',
      padding: '10px 0px 5px',
    },
    observationText: {
      fontSize: 12,
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
    },
  });
